$(document).on("ready", function()
{
    // Vidéos (block)
    $(".ficheproduit2__video_item").magnificPopup({
        "callbacks": {
            "beforeOpen": function()
            {
                $(".btCloseRightItem").css("z-index", 20);
                const selectedVideoURL = $(".ficheproduit2__video_item[data-url]").eq(this.index).attr("data-url");
                this.items = [];
                this.items.push({ "src": selectedVideoURL });
                this.index = 0; // forces index 0 for MFP
                this.updateItemHTML();
            },
            "beforeClose": function()
            {
                $(".btCloseRightItem").css("z-index", 1500);
            }
        },
        "gallery": {
            "enabled": false
        },
        "showCloseBtn": true,
        "closeBtnInside": false,
        "closeOnContentClick": false,
        "type": "iframe",
        "iframe": {
            "markup": '<div class="mfp-iframe-scaler">'+
                '<div class="mfp-close"></div>'+
                '<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'+
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
            "patterns": {
                "youtube": {
                    "index": "youtube:", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                    "id": ":", // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
                    "src": "https://www.youtube.com/embed/%id%?autoplay=1" // add &mute=1 for autoplay to work but no sound // URL that will be set as a source for iframe.
                },
                "kzam": {
                    "index": getConfig("url"),
                    "id": null, //url => url,
                    "src": "%id%"
                }
            },
        }
    });
});